import Component from "vue-class-component";
import SelectTimeProps from "./SelectTimeProps";
import AppointmentService from "@/api/Services/Appointment";
import AlertMessage from "@/components/Util/AlertMessage/AlertMessage.vue";
import { SelectTimeInterface } from "./SelectTimeInterface";
import { bus } from "@/main";
import { mapGetters } from "vuex";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

@Component<ServiceTimeSelect>({
  name: "ServiceTimeSelect",
  components: {
    AlertMessage,
  },
  computed: mapGetters(["getSearchDate", "getClinicId", "getTime"]),
})
export default class ServiceTimeSelect extends SelectTimeProps {
  getSearchDate!: string;
  getClinicId!: string;
  getTime!: SelectTimeInterface;
  cx_times: SelectTimeInterface[] = [];

  requestError = false;

  constructor() {
    super();
  }

  mounted(): void {
    this.getHoursAvailableClinics();
    GoogleAnalyticsEvents.loadHourSelection();
    this.selectTime(this.getTime);
  }

  getHoursAvailableClinics(): void {
    this.cx_times = [];
    this.$emit("setLoading", true);

    if (this.getClinicId && this.getSearchDate) {
      const date = new Date(this.getSearchDate);
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getUTCDate().toString().padStart(2, "0");
      const dateApi = `${year}-${month}-${day}`;

      AppointmentService.getHoursAvailable(this.getClinicId, dateApi)
        .then((response: any) => {
          response.data.data.forEach((hour: SelectTimeInterface) => {
            this.$emit("requestError", false);

            const tmp: SelectTimeInterface = {
              id: this.cx_times.length,
              time: hour.start,
              end: hour.end,
              available: hour.available,
              selected: hour.selected || false,
            };

            this.cx_times.push(tmp);
            if (this.getTime) {
              this.selectTime(this.getTime);
            }
          });
        })
        .catch((error) => {
          this.$emit("requestError", true);
          console.log(error);
        })
        .finally(() => setTimeout(() => this.$emit("setLoading", false), 500));
    }
  }

  selectTime(item: SelectTimeInterface): void {
    if (!item.available) return;

    const times = this.cx_times;

    for (const index of this.cx_times.keys()) {
      times[index].selected = times[index].id === item.id;
    }

    this.cx_times = times;

    this.$store.commit("setTime", item);
    this.$emit("disableNext");
  }

  get selected(): SelectTimeInterface | undefined {
    return this.cx_times.find((i) => i.selected);
  }
}
